import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class VidalService {
	constructor(private http: HttpClient) { }

	search(query:string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.vidal:search',
			params: {
				query: query,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	product(id: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.vidal:product',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	
	
}